import FlexView from "react-flexview";
import SimpleButton from "../../../modules/commons/SimpleButton";
import React from "react";
import SimpleInput from "../../../modules/SimpleInput";
import SimpleDDL from "../../../modules/SimpleDDL";
import {mapToDDL} from "../../common/mapper";
import M from "moment";

export const formGroupMasterBBN = {
    bbnName: {value: "", mandatory: true},
    startDate: {value: null, mandatory: true},
    endDate: {value: null, mandatory: true},
    kodeSamsat: {value: [], mandatory: true},
    variants: {value: []},
};

export const initialData = {
    search: {
        startDate: M().format("DD-MM-YYYY"),
        endDate: M().format("DD-MM-YYYY"),
    },
    filter: {
        bbnName: null,
        startDate: null,
        endDate: null,
        kodeSamsat: null,
        kodeVariant: null,
    },
    detail: {
        kodeVariant: null,
        namaVariant: null,
        bbnPrice: null,
        differenceIncomeBbn: null,
    }
}

export const tableColumns = {
    mainPage: (menuAccess, dataTable, handleModifyingModalVisibility, handleDelete) => {
        return [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        const {page, rowsPerPage} = tableMeta.tableState;
                        const rowNumber = page * rowsPerPage + tableMeta.rowIndex + 1;

                        return <>{rowNumber}</>;
                    },
                    sort: false,
                },
            },
            {
                name: "bbnName",
                label: "Nama Tabel BBN",
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "startDate",
                label: "Tanggal Awal",
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "endDate",
                label: "Tanggal Akhir",
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "samsat",
                label: "SAMSAT",
                options: {
                    customBodyRender: (val) => <p>{val}</p>,
                    sort: false,
                },
            },
            {
                name: "",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return (
                            <FlexView vAlignContent="center">
                                {menuAccess && menuAccess.updateAccess && (
                                    <SimpleButton
                                        category="action_button"
                                        style={{marginRight: 15, backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}}
                                                 className="fa fa-lw fa-pencil-alt"/>}
                                        onClick={() => handleModifyingModalVisibility(tableMeta.rowIndex)}
                                    />
                                )}
                                {menuAccess && menuAccess.updateAccess && (
                                    <SimpleButton
                                        category="action_button"
                                        style={{marginRight: 15, backgroundColor: "transparent"}}
                                        icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                        onClick={() => handleDelete(tableMeta.rowIndex)}
                                    />
                                )}
                            </FlexView>
                        );
                    },
                    sort: false,
                },
            },
        ];
    },
    detailPage: (
    menuAccess,
    dataVariant,
    deleteAction,
    handleVariantChange,
    handleValueChange,
    handleDelete,
    activityType,
    handleRefreshDataVariant,
    dataKodeUnitPabrik,
    handleKodeUnitPabrikChange,
    handleRefreshKodeUnitPabrik
  ) => {
        return [
            {
                name: "",
                label: "No",
                options: {
                    customBodyRender: (value, tableMeta) => {
                        return <>{tableMeta.rowIndex + 1}</>;
                    },
                    sort: false,
                },
            },
            {
                name: "kodeVariant",
                label: "Kode Varian",
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <SimpleDDL
                                id={`select_options_category_${tableMeta.rowIndex}`}
                                containerclassname="margin-bottom-none width width-200px"
                                name="kodeVariant"
                                box="search"
                                menuPosition="fixed"
                                readOnly={deleteAction}
                                options={dataVariant}
                                value={val}
                                onChange={(value, {name}) => handleVariantChange(tableMeta.rowIndex, name, value)}
                                onMenuOpen={() => handleRefreshDataVariant(tableMeta)}
                            />
                        )
                    },
                    sort: false,
                },
            },
            {
                name: "kodeUnitPabrik",
                label: "Kode Unit Pabrik",
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <SimpleDDL
                                id={`select_options_category_${tableMeta.rowIndex}`}
                                containerclassname="margin-bottom-none width width-200px"
                                name="kodeUnitPabrik"
                                box="search"
                                menuPosition="fixed"
                                readOnly={deleteAction}
                                options={dataKodeUnitPabrik}
                                value={mapToDDL(val, val)}
                                onChange={(value, {name}) => handleKodeUnitPabrikChange(tableMeta.rowIndex, name, value)}
                                onMenuOpen={() => handleRefreshKodeUnitPabrik(tableMeta)}
                            />
                        )
                    },
                    sort: false,
                },
            },
            {
                name: "namaVariant",
                label: "Nama Varian",
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <SimpleInput
                                readOnly
                                id="input_text_kodeKSU"
                                name="namaVariant"
                                containerclassname="margin-bottom-none width width-200px"
                                value={val}
                            />
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "bbnPrice",
                label: "Harga BBN",
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <SimpleInput
                                id="input_text_kodeKSU"
                                box="onlyNumber"
                                name="bbnPrice"
                                readOnly={deleteAction}
                                containerclassname="margin-bottom-none width width-200px"
                                value={val}
                                onChange={({target}) => handleValueChange(tableMeta.rowIndex, target.name, target.value)}
                            />
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "differenceIncomeBbn",
                label: "Pendapatan Selisih BBN",
                options: {
                    customBodyRender: (val, tableMeta) => {
                        return (
                            <SimpleInput
                                id="input_text_kodeKSU"
                                box="onlyNumber"
                                name="differenceIncomeBbn"
                                readOnly={deleteAction}
                                containerclassname="margin-bottom-none width width-200px"
                                value={val}
                                onChange={({target}) => handleValueChange(tableMeta.rowIndex, target.name, target.value)}
                            />
                        )
                    },
                    sort: false,
                }
            },
            {
                name: "",
                label: "Aksi",
                options: {
                    customBodyRender: (_, tableMeta) => {
                        return (
                            <FlexView vAlignContent="center">
                                {
                                    menuAccess && menuAccess.deleteAccess && deleteAction
                                        ?
                                        <SimpleButton
                                            category="action_button"
                                            style={{marginRight: 15, backgroundColor: "transparent"}}
                                            icon={<i style={{fontSize: 20, color: "silver"}} className="fa fa-trash"/>}
                                        />
                                        :
                                        menuAccess && menuAccess.deleteAccess && (
                                            <SimpleButton
                                                category="action_button"
                                                style={{marginRight: 15, backgroundColor: "transparent"}}
                                                icon={<i style={{fontSize: 20, color: "red"}} className="fa fa-trash"/>}
                                                onClick={() => handleDelete(tableMeta.rowIndex)}
                                            />
                                        )

                                }
                            </FlexView>
                        );
                    },
                    sort: false,
                },
            }
        ]
    }
}